export default {"src":"/_next/static/image/public/images/ic_rx_medicines.6c99ad4bbb409c4e5181107f6a3f4b58.svg","height":48,"width":48};